module.exports = __webpack_public_path__ + "static/media/GalleryMain5.be91ab3d.jpg";